import Service from "@/controllers/Service.controller.js";
import GestaoSocio from "@/controllers/GestaoSocio.controller.js";
import StorageTable from "@/controllers/Storage.controller.js";

import Vue from "vue";

export default class Facial extends StorageTable {
    constructor() {
        super();
        this.$gestaoSocio = new GestaoSocio();
        this.contratos = [];
        this.cartoes = [];
        this.liberaFacial = false;
        this.liberaEmprestimo = false;
    }

    async getVue() {
        if (this.$root) {
            return this.$root;
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.$root = document.querySelector("#app").__vue__.$root;
        return this.$root;
    }

    async getStatusFacial() {
        // FUNC: getStatusFacial()
        // CC:
        const service = new Service();
        const session = this.getLocal("session");

        return await service.get(
            "GETSTATUSFACIAL",
            "?idpessoa=" + session.idpessoa
        );
    }

    vinculaFacial() {
        // Cadastro Facial
        const service = new Service();
        // console.log(service.BASE_URL
        //     + 'FacialRecognition?close_page=true&access_token=' + this.getLocal("token")
        //     + '&url_redirect=' + 'https://socioahinter.eleventickets.com/pt/gestaoFacial')

        this.removeLocal("foto_sessao");

        window.location =
            service.BASE_URL +
            "FacialRecognition?" +
            "&url_redirect=" +
            encodeURIComponent(window.location.href) +
            "&access_token=" +
            this.getLocal("token");
        // window.open(service.BASE_URL
        //     + 'FacialRecognition?'
        //     + '&url_redirect=' + encodeURIComponent(window.location.href)
        //     + '&access_token=' + this.getLocal("token"), '_blank')
    }

    async getConvidadosfacial(params) {
        const service = new Service();
        return await service.post("GETCONVIDADOS", params);
    }

    async getIngressosContrato(params) {
        const dados = Buffer.from(JSON.stringify(params), "utf-8").toString(
            "base64"
        );

        const service = new Service();
        return await service.get("GETINGRESSOSFACIAL", dados);
    }

    async setConvidado(params) {
        const service = new Service();
        return await service.post("SETCONVIDADO", params);
    }

    async deleteConvidado(id) {
        const service = new Service();
        return await service.delete("DELETECONVIDADO", id);
    }

    async getContratosFacial() {
        if (this.getLocal("contratos")) {
            this.contratos = this.getLocal("contratos");
            window.$root.sociedades = this.contratos;
        } else {
            await this.$gestaoSocio
                .gsContratosStatus()
                .then((contratosPessoa) => {
                    if (contratosPessoa) {
                        this.contratos = contratosPessoa;
                        this.setLocal("contratos", contratosPessoa);
                    } else {
                        this.contratos = [];
                    }
                    window.$root.sociedades = this.contratos;
                });
        }

        if (this.getLocal("cartoes_contratos")) {
            this.cartoes = this.getLocal("cartoes_contratos");
        } else {
            this.cartoes = await this.$gestaoSocio.gsCartoes({
                status: "ativo",
            });
            this.setLocal("cartoes_contratos", this.cartoes);
        }

        for (const cont of this.contratos) {
            this.cartoes.forEach((cart) => {
                if (
                    cont.idcontrato === cart.idcontrato &&
                    cart.idcartao_status == 105
                ) {
                    cont.cartao = cart.cartao;
                }
            });
        }

        return this.contratos;
    }

    async vinculaConvidado(params) {
        const service = new Service();

        return await service.post("VINCULACONVIDADO", params);
    }

    async validaPermicaoFacial() {
        let libera = false;
        let emprestimo = false;
        const root = await this.getVue();
        const session = window.$storage.getLocal("session");

        // Libera emprestimo de carteirinha para publico sócio e para tipo de pessoa parametrizado
        if (
            session.idpessoa_tipo == 100002 ||
            session.idpessoa_tipo == root.config.libera_convidados_tipoPessoa
        ) {
            await this.getContratosFacial();

            for (let i = 0; i < this.contratos.length; i++) {
                const contrato = this.contratos[i];

                if (contrato?.libera_cadastro_facial == 1) {
                    libera = true;
                }
                if (contrato?.libera_cadastro_facial_guest == 1) {
                    emprestimo = true;
                }
            }
        } else {
            libera = root.config.libera_facial_pg;
        }

        this.liberaFacial = libera;
        this.liberaEmprestimo = emprestimo;
    }

    async getPeriodos() {
        const service = new Service();

        let res = await service.get("GETFACIALCONFIGS");
        return !res.error ? res : false;
    }

    async getConvitesRecebidos(idpessoa, page = 1, total = 5) {
        const service = new Service();
        let dados = {
            idpessoa: idpessoa,
            page: page,
            max_result: total,
        };

        const params = Buffer.from(JSON.stringify(dados), "utf-8").toString(
            "base64"
        );

        let res = await service.get("GETCONVITES", params);
        return !res.error ? res : false;
    }

    async removeConvinte(dados) {
        const service = new Service();

        let res = await service.post("REMOVECONVITE", dados);
        return !res.error ? res : false;
    }

    async vinculaFacialEmContrato(params) {
        const service = new Service();

        return await service.post("SETFACIALCONTRATO", params);
    }
    async getfacialHolder(idpessoa) {
        const service = new Service();

        const params = Buffer.from(
            JSON.stringify({ idpessoa: idpessoa }),
            "utf-8"
        ).toString("base64");

        const res = await service.get("GETFACIALHOLDER", params);

        if (!res || res?.length == 0) {
            return false;
        } else {
            return res;
        }
    }

    async removerMeuAcesso(dados) {
        const service = new Service();

        let res = await service.post("REMOVEHOLDER", dados);
        return !res.error ? res : false;
    }
    async consultaGuestInTicket(cartao, idpessoa_convidado) {
        const service = new Service();

        return await service.get(
            "GUESTINTICKET",
            cartao + "/" + idpessoa_convidado
        );
    }
}
Vue.prototype.$facial = new Facial();
window.$facial = new Facial();
